import I18n from 'I18n';
import { PageTypes, Paths } from '../../../components/RoutesPublic';
import { addLabelAndVerifyBadge } from '../navUtils';
import memoize from 'react-utils/memoize';
import { navigation } from 'developer-docs-source/navigation';

/**
 * 'API & Reference' > 'API Endpoints' nav config.
 * TODO: Localize
 */
export const apiEndpointsNavConfig = memoize(() => {
  const commonPath = `${Paths.REFERENCE}/api`;
  const nav = navigation[commonPath];
  const navigationItems = nav.items.map(item => {
    return addLabelAndVerifyBadge(item);
  });
  const config = {
    locatorPageType: PageTypes.REFERENCE,
    sectionLabel: I18n.text('developer-docs-ui.navigation.reference.apiEndpoints'),
    commonPath,
    items: navigationItems
  };
  return config;
});